import { useEffect, useState } from 'react';
import { fetchPilotStatus } from '@/lib/marketExperienceApi';
import { isPilotModeOn } from '@/lib/pilotMode';

const cache = new Map();
const inflight = new Map();

function cacheKey(tenantId) {
  return String(tenantId || '');
}

export function invalidatePilotStatus(tenantId) {
  if (tenantId) cache.delete(cacheKey(tenantId));
  else cache.clear();
}

function load(tenantId) {
  const key = cacheKey(tenantId);
  if (cache.has(key)) return Promise.resolve(cache.get(key));
  if (inflight.has(key)) return inflight.get(key);
  const promise = fetchPilotStatus(tenantId)
    .then((data) => {
      cache.set(key, data);
      return data;
    })
    .finally(() => {
      inflight.delete(key);
    });
  inflight.set(key, promise);
  return promise;
}

export function usePilotStatus(tenantId, { refreshKey = 0 } = {}) {
  const [status, setStatus] = useState(() => (tenantId ? cache.get(cacheKey(tenantId)) || null : null));

  useEffect(() => {
    if (!tenantId) {
      setStatus(null);
      return undefined;
    }
    let cancelled = false;
    if (refreshKey) cache.delete(cacheKey(tenantId));
    load(tenantId)
      .then((data) => {
        if (!cancelled) setStatus(data);
      })
      .catch(() => {
        if (!cancelled) setStatus({ pilot_mode: false, label: null });
      });
    return () => { cancelled = true; };
  }, [tenantId, refreshKey]);

  return {
    status,
    pilotMode: isPilotModeOn(status),
  };
}
